import React, { FC, useEffect, useState } from 'react'
import { Button } from '../../../../ps-aspect-design';
import { useHistory, useLocation } from 'react-router-dom';
import { useQueryParams } from '../../../../hooks/util'
import SuperAdminList from './SuperAdmins/SuperAdminList/SuperAdminList';
import AddSuperAdmin from './SuperAdmins/AddSuperAdmin/AddSuperAdmin';
import PermittedDomains from './SuperAdmins/PermittedDomains/PermittedDomains';
import UserLookup from './UserLookup/UserLookup';
import '../../MarketPayInternal.scss';

interface ManageUsersView {
    key: ManageUsersViewKey
    label: ManageUsersViewLabel
    Component: FC
    queryParam: string
}

type ManageUsersViewKey = 'SUPERADMIN_LIST' | 'SUPERADMIN_ADD' | 'AUDIT_TRAIL' | 'PERMITTED_DOMAINS' | 'USER_LOOKUP' | undefined
type ManageUsersViewLabel = 'Super Admin List' | 'Add Super Admin' | 'Audit Trail' | 'Permitted Email Domains' | 'User Lookup'

const ManageUsers = () => {
    const [view, setView] = useState<ManageUsersViewKey>('SUPERADMIN_LIST');
    const history = useHistory();
    const location = useLocation();
    const query = useQueryParams()
    const userTab = query.get('userTab')

    const VIEWS: ManageUsersView[] = [
        { key: 'SUPERADMIN_LIST', label: 'Super Admin List', Component: SuperAdminList, queryParam: 'superadminlist' },
        { key: 'SUPERADMIN_ADD', label: 'Add Super Admin', Component: AddSuperAdmin, queryParam: 'addsuperadmin' },
        { key: 'PERMITTED_DOMAINS', label: 'Permitted Email Domains', Component: PermittedDomains, queryParam: 'permittedemaildomains' },
        { key: 'USER_LOOKUP', label: 'User Lookup', Component: UserLookup, queryParam: 'userlookup' },
    ]

    const handleViewChange = (view: ManageUsersView) => {
        setView(view.key)
        const params = new URLSearchParams(location.search);
        params.set('userTab', view.queryParam);
        history.push({ search: params.toString() });
    }

    useEffect(() => {
        if (userTab?.toLocaleLowerCase() === 'superadminlist') setView('SUPERADMIN_LIST')
        if (userTab?.toLocaleLowerCase() === 'addsuperadmin') setView('SUPERADMIN_ADD')
        if (userTab?.toLocaleLowerCase() === 'permittedemaildomains') setView('PERMITTED_DOMAINS')
        if (userTab?.toLocaleLowerCase() === 'userlookup') setView('USER_LOOKUP')
    }, [userTab])

    return (
        <div>
            {VIEWS.map(v =>
                <Button
                    key={v.key}
                    variant={v.key === view ? 'primary' : 'secondary'}
                    onClick={() => handleViewChange(v)}
                >
                    {v.label}
                </Button>)
            }

            <div className="view__container">
                {VIEWS.map(v => (v.key === view && <v.Component key={v.key} />))}
            </div>

        </div>
    )
}

export default ManageUsers